import React from "react";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { parseISO } from "date-fns";
import { Typography } from "@mui/material";
import { MARKETPLACE_CONSTANTS } from "../../../../config/constants";

/**
 * DisplayPeriod Component
 *
 * Date picker component for selecting product display period (start and end dates)
 */
const DisplayPeriod = ({
  dateFrom,
  dateTo,
  onDateFromChange,
  onDateToChange,
}) => {
  return (
    <div className="configuration-page">
      <div className="configuration-general">
        <Typography variant="h5" className="mb-4">
          {MARKETPLACE_CONSTANTS.DISPLAY_PERIOD}
        </Typography>
      </div>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <div
          className="d-flex justify-content-between align-items-center mb-4 mx-4"
          style={{ gap: 8 }}
        >
          <DatePicker
            slotProps={{
              textField: {
                variant: "outlined",
                fullWidth: true,
              },
            }}
            format={MARKETPLACE_CONSTANTS.DATE_FORMAT}
            label={MARKETPLACE_CONSTANTS.START_DATE}
            value={dateFrom ? parseISO(dateFrom) : null}
            minDate={new Date()}
            onChange={onDateFromChange}
          />
          <DatePicker
            slotProps={{
              textField: {
                fullWidth: true,
                variant: "outlined",
              },
            }}
            format={MARKETPLACE_CONSTANTS.DATE_FORMAT}
            label={MARKETPLACE_CONSTANTS.END_DATE}
            value={dateTo ? parseISO(dateTo) : null}
            onChange={onDateToChange}
            minDate={dateFrom ? parseISO(dateFrom) : undefined}
          />
        </div>
      </LocalizationProvider>
    </div>
  );
};

export default DisplayPeriod;
